'use client'

import Image from 'next/image'

import { ampli } from '@src/ampli-web'
import { Container } from '@src/components/Container/Container'
import { useTrackSelectCta } from '@src/utils/analytics.util'
import { cn } from '@src/utils/tailwind'

import { LocalizedLink } from '../LocalizedLink/LocalizedLink'

interface SmallFooterProps {
  copyright: string
  links: Array<{ label: string; href: string }>
  badges: Array<{ url: string; altText: string }>
}

export function SmallFooter({ copyright, links, badges }: SmallFooterProps) {
  const trackSelectCta = useTrackSelectCta()

  return (
    <div className={cn('border-t-2 border-bodi-gray-light bg-bodi-gray-pearl')}>
      <Container
        className={cn(
          'grid grid-flow-row gap-5 px-6 py-9 text-center text-body-xs lg:grid-flow-col lg:px-40 lg:py-5 lg:text-left'
        )}
      >
        <div className={cn('flex flex-col justify-center gap-5 lg:grow lg:justify-start lg:gap-1')}>
          <div>{copyright}</div>

          <div>
            {links.map((link, index) => (
              <LocalizedLink
                key={`${link.href}-${index}`}
                href={link.href}
                className="inline-block"
                target="_blank"
                onClick={() => {
                  trackSelectCta({ 'cta url': link.href })
                  ampli.flush()
                }}
              >
                <div className={cn({ "after:mx-1 after:content-['|']": index < links.length - 1 })}>
                  {link.label}
                </div>
              </LocalizedLink>
            ))}
          </div>
        </div>

        {badges?.length && (
          <div className={cn('flex flex-wrap justify-center gap-6 lg:flex-nowrap lg:justify-end')}>
            {badges.map((badge, index) => (
              <Image
                key={`${badge.url}-${index}`}
                className="h-8 w-auto"
                src={badge.url}
                width={250}
                height={250}
                alt={badge.altText}
              />
            ))}
          </div>
        )}
      </Container>
    </div>
  )
}
